// gestion des cookies depuis le service externe axeptio

const element = document.querySelector('.open-axeptio')

if (element) {
  element.addEventListener(
    'click',
    (e) => {
      window.openAxeptioCookies()
      e.preventDefault()
    },
    false
  )
}
